export default __webpack_public_path__ + "static/media/img-team-advisros-sh3x.f90c4bb1.png";